export default "__VITE_ASSET__CpcKVTfA__"